/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs */

const en_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We notify you about your trial end`)
};

const ar_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنخطرك بانتهاء الفترة التجريبية`)
};

const de_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir benachrichtigen Sie über das Ende Ihres Trails`)
};

const es_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te notificaremos el final de la prueba`)
};

const fr_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous vous informons de la fin de votre essai`)
};

const it_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti informiamo della fine della prova`)
};

const ja_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル終了をお知らせします`)
};

const ko_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험판이 끝날 때쯤 알려드려요`)
};

const pt_br_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós notificamos sobre o encerramento do período de teste`)
};

const ru_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы уведомим вас об окончании пробной версии`)
};

const th_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราแจ้งให้คุณทราบถึงวันสิ้นสุดการทดลองของคุณ`)
};

const tr_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme süren sona erdiğinde seni bilgilendireceğiz`)
};

const zh_cn_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们会提醒你免费试用即将结束`)
};

const zh_tw_subscription_walkthrough_p3_1_day_before_trail_note = /** @type {(inputs: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們會提醒你免費試用即將結束`)
};

/**
* | output |
* | --- |
* | "We notify you about your trial end" |
*
* @param {Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_1_day_before_trail_note = /** @type {((inputs?: Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_1_Day_Before_Trail_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
	return zh_tw_subscription_walkthrough_p3_1_day_before_trail_note(inputs)
});